import clsx from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';

type ShiningPropsType = ComponentPropsWithoutRef<'div'>;

const Shining = ({ className, ...restProps }: ShiningPropsType) => (
    <div className={clsx('shining', className)} {...restProps} />
);

export default Shining;
